import { useState, useEffect, useCallback } from 'react';
import wsService from '../WebSocket/WebSocketService';
import { WS_EVENTS } from '../WebSocket/constants';

export const useWebSocket = ({ userId, orgId }) => {
    const [connectionStatus, setConnectionStatus] = useState('Disconnected');
    const [messageAll, setMessageAll] = useState([]);
    const [messageUpdate, setMessageUpdate] = useState([]);
    const [messageSend, setMessageSend] = useState([]);
    const session = localStorage.getItem("session");
    const handleMessages = useCallback((messages) => {
        // setMessageAll([]);
        // setMessageSend([]);
        setMessageAll(messages)
        // messages.forEach(message => {
        //     const setter = message.fromOrganisationId === message.toOrganisationId
        //         ? setMessageSend
        //         : setMessageAll;
        //     setter(prev => [...prev, message]);
        // });
    }, []);

    // const handleUpdate = useCallback((messages) => {
    //     setMessageUpdate(messages)
    // }, []);

    const getMessages = useCallback((params) => {
        return wsService.getMessages(params);
    }, []);

    const getUpdate = useCallback((params) => {
        return wsService.getUpdateChat(params);
    }, []);

    const sendMessage = useCallback((messageData) => {
        return wsService.sendChatMessage(messageData);
    }, []);

    useEffect(() => {
        if (orgId && session) {
            wsService.connect({ userId, orgId, session });

            const removeMessageHandler = wsService.onMessage(
                WS_EVENTS.GET_MESSAGES,
                (message) => {
                    if (message.data) {
                        handleMessages(message.data);
                    }
                }
            );


            const setMessageUpdateData = wsService.onMessage(
                WS_EVENTS.GET_UPDATES,
                (message) => {
                    if (message.data) {
                        setMessageUpdate(message.data);
                    }
                }
            );



            const removeSendHandler = wsService.onMessage(
                WS_EVENTS.SEND_MESSAGE,
                (message) => {
                    if (message.data) {
                        getMessages({
                            organisationId: orgId,
                            questionFormId: message.data.questionFormId,
                            questionCategoryId: message.data.questionCategoryId,
                            questionId: message.data.questionId
                        });
                    }
                }
            );

            const removeConnectionHandler = wsService.onConnectionChange((status) => {
                setConnectionStatus(status);
            });

            return () => {
                removeMessageHandler();
                removeSendHandler();
                setMessageUpdateData();
                removeConnectionHandler();
            };
        }
    }, [userId, orgId, handleMessages, getMessages, session]);

    return {
        connectionStatus,
        messageAll,
        messageSend,
        messageUpdate,
        sendMessage,
        getMessages,
        getUpdate
    };
};
